// Generated types for GlossaryTerm
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { CatalogNodeReadAPI, CatalogNodeWriteAPI } from '../../shared/types/catalognode';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { CatalogNodeReadAPISchemaObject, CatalogNodeWriteAPISchemaObject } from '../../shared/types/catalognode';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface GlossaryTermReadAPI extends CatalogNodeReadAPI, RFLPElementReadAPI {
  /** The definition of the term — what it means in this workspace. */
  definition: string;
  /** Synonyms / alternate spellings / abbreviations of the canonical term (e.g. 'UAV' for 'Drone'). */
  aliases?: string[];
  /** Optional subdomain tag (e.g. 'hardware', 'regulatory', 'user-facing'). Free-form free for now; future filtering may use it. */
  domain?: string | null;
}

export interface GlossaryTermWriteAPI extends CatalogNodeWriteAPI, RFLPElementWriteAPI {
  /** The definition of the term — what it means in this workspace. */
  definition: string;
  /** Synonyms / alternate spellings / abbreviations of the canonical term (e.g. 'UAV' for 'Drone'). */
  aliases?: string[];
  /** Optional subdomain tag (e.g. 'hardware', 'regulatory', 'user-facing'). Free-form free for now; future filtering may use it. */
  domain?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const GlossaryTermReadAPISchema: z.ZodType<GlossaryTermReadAPI> = CatalogNodeReadAPISchemaObject.extend(RFLPElementReadAPISchemaObject.shape).extend({
  definition: z.string(),
  aliases: z.array(z.string()).optional(),
  domain: z.string().nullable().optional(),
}).passthrough();

export const GlossaryTermWriteAPISchema: z.ZodType<GlossaryTermWriteAPI> = CatalogNodeWriteAPISchemaObject.extend(RFLPElementWriteAPISchemaObject.shape).extend({
  definition: z.string(),
  aliases: z.array(z.string()).optional(),
  domain: z.string().nullable().optional(),
}).passthrough();
